import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

const BackgroundAudioPlayer = ({ audioUrls }) => {
  const audioRef = useRef(null);
  const [currentTrackIndex, setCurrentTrackIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const playAudio = () => {
    if (audioRef.current) {
      audioRef.current.play().catch((error) => {
        console.error('Audio play failed:', error);
      });
      setIsPlaying(true);
    }
  };

  useEffect(() => {
    if (audioRef.current && isPlaying) {
      audioRef.current.volume = 1.0; // Set volume to 100%
      audioRef.current.play().catch((error) => {
        console.error('Audio play failed:', error);
      });
    }

    const handleAudioEnd = () => {
      if (audioUrls.length === 1) {
        audioRef.current.play();
      } else {
        const nextTrackIndex = (currentTrackIndex + 1) % audioUrls.length;
        setCurrentTrackIndex(nextTrackIndex);
      }
    };

    const audioElement = audioRef.current;
    audioElement.addEventListener('ended', handleAudioEnd);

    return () => {
      audioElement.removeEventListener('ended', handleAudioEnd);
    };
  }, [audioUrls, currentTrackIndex, isPlaying]);

  useEffect(() => {
    if (audioRef.current && isPlaying) {
      audioRef.current.src = audioUrls[currentTrackIndex];
      audioRef.current.play().catch((error) => {
        console.error('Audio play failed:', error);
      });
    }
  }, [currentTrackIndex, audioUrls, isPlaying]);

  return (
    <div>
      {!isPlaying && <button onClick={playAudio}>Play Background Music</button>}
      <audio
        ref={audioRef}
        style={{ display: 'none' }}
        src={audioUrls[currentTrackIndex]}
        loop={audioUrls.length === 1}
      />
    </div>
  );
};

BackgroundAudioPlayer.propTypes = {
  audioUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default BackgroundAudioPlayer;
